/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXblrShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="m6.807 17 1.5-2.526L6.88 12.13h1.2l1.005 1.682.978-1.682h1.152l-1.434 2.365L11.29 17h-1.2l-1.085-1.842L7.96 17zm5.015 0v-4.87h1.708c.621 0 1.077.104 1.367.314.295.21.442.536.442.978 0 .22-.058.416-.174.59a1.222 1.222 0 0 1-.482.415c.576.179.864.56.864 1.146 0 .951-.659 1.427-1.977 1.427zm1.005-2.854h.509c.353 0 .6-.045.743-.134.148-.094.222-.25.222-.47 0-.227-.072-.386-.215-.475-.143-.094-.393-.14-.75-.14h-.51zm0 2.05h.663c.344 0 .596-.054.757-.16s.241-.275.241-.503c0-.224-.08-.387-.241-.49-.16-.102-.413-.153-.757-.153h-.663zm3.372.804v-4.87h1.87c.58 0 1.026.133 1.34.401.312.268.468.648.468 1.14 0 .343-.09.636-.268.877a1.417 1.417 0 0 1-.744.516L20.085 17h-1.153l-1.031-1.749-.664-.167V17zm1.038-2.6h.51c.406 0 .687-.05.844-.154.16-.107.241-.292.241-.556 0-.263-.08-.446-.241-.55-.157-.106-.438-.16-.844-.16h-.51zm3.378 2.6v-4.87h1.046v3.939h2.144V17zm-18.141.474L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXblrShortcut as FileXblrShortcut };
